<div class="vo-inquiry">
  <app-inquiry-header/>

  <app-inquiry-step1 *ngIf="currentStep === 1"/>

  <div class="vo-flow" *ngIf="isFormStep">
    <app-inquiry-sidebar class="vo-sidebar"/>

    <main class="vo-main" [ngSwitch]="currentStep">
      <app-inquiry-step2 *ngSwitchCase="2"/>
      <app-inquiry-step2-1 *ngSwitchCase="2.1"/>
      <app-inquiry-step2-5 *ngSwitchCase="2.5"/>
      <app-inquiry-step3 *ngSwitchCase="3"/>
      <app-inquiry-step3-5 *ngSwitchCase="3.5"/>
      <app-inquiry-step4 *ngSwitchCase="4"/>
    </main>
  </div>

  <app-inquiry-summary *ngIf="currentStep === 'summary'"/>

  <app-recaptcha-attribution/>
</div>
